import Functions from "./index.functions.js";
const FormStep = ({
  step,
  control,
  register,
  errors,
  setValue,
  watch,
  select,
  setSelect,
  links,
  setLinks,
  selectedPlatform,
  setSelectedPlatform,
  linksErrors,
  setLinksErrors,
  setCountryCode,
  isOfScreen,
  otherExperienceId,
  otherLanguageId,
}) => {
  const { StepComponent } = Functions(step, isOfScreen);
  return (
    <StepComponent
      register={register}
      setValue={setValue}
      links={links}
      setLinks={setLinks}
      select={select}
      setSelect={setSelect}
      selectedPlatform={selectedPlatform}
      setSelectedPlatform={setSelectedPlatform}
      linksErrors={linksErrors}
      setLinksErrors={setLinksErrors}
      control={control}
      watch={watch}
      errors={errors}
      setCountryCode={setCountryCode}
      otherExperienceId={otherExperienceId}
      otherLanguageId={otherLanguageId}
    />
  );
};
export default FormStep;
